<!--养护卡 卡内项目-->
<template lang="pug">
  modal-dialog(modal-scale="large")
    .modal-card(slot="card")
      .modal-header
        .modal-card-title 项目
        .close-button(@click="modalClose")
      .modal-body
        .content-box(v-if="list.length > 0")
          .h2 卡内项目
          .div-cell.cell-head
            .cell-name 项目名称
            .cell-desc 项目描述
            .w-25-p(v-if="from!=='shell-card-detail'") 有效期
            .w-45-p(v-if="from!=='shell-card-detail'") 项目到期日
            .cell-num 次数
            .cell-end(v-if="type === 1") 是否为最终项目
          .div-cell.cell-body(v-for="item in list")
            .cell-name.cell {{item.name}}
            .cell-desc.cell {{item.description}}
            .w-25-p.cell(v-if="from!=='shell-card-detail'") {{item.expiry}}{{expiry_type == 1 ? '月': '天'}}
            .w-45-p.cell(v-if="from!=='shell-card-detail'")
              span(v-if="!end_time_editable") {{item.end_time | formatterDate("yyyy-MM-dd hh:mm:ss")}}
              el-date-picker(style="width: 150px" v-else v-model="item.end_time_temp" value-format="timestamp" :clearable="false" size='mini' type="datetime" placeholder="选择日期" class="el-date-picker-dom")
            .cell-num.cell
              span(v-if="item.num == 0") 无限次
              span(v-if="item.num != 0") {{item.num}}次
            .cell-end.cell(v-if="type === 1")
              span(v-if="item.is_end && item.is_end == 1") 是
              span(v-if="item.is_end && item.is_end == 2") 否
        .content-box(v-if="item.length > 0 && type === 1")
          .h2 免激活项目
          .div-cell.cell-head
            .cell-name 项目名称
            .cell-desc 项目描述
            .w-25-p 有效期
            .w-45-p 项目到期日
            .cell-end 次数
          .div-cell.cell-body(v-for="cell in item")
            .cell-name.cell {{cell.name}}
            .cell-desc.cell {{cell.description}}
            .w-25-p.cell {{cell.expiry}}{{expiry_type == 1 ? '月': '天'}}
            .w-45-p.cell {{cell.end_time | formatterDate("yyyy-MM-dd hh:mm:ss")}}
            .cell-end.cell
              span(v-if="cell.num == 0") 无限次
              span(v-if="cell.num != 0") {{cell.num}}次
      //- 仅客户管理-养护卡-养护卡详情弹出层-点击查看是可编辑的（此处未区分具体卡类型，即壳养护卡、主卡、次卡均可编辑）
      .modal-footer(v-if="from==='customer-detail'")
        .flex-end
          .button.primary.m-t-10(v-if='!end_time_editable' type="primary" @click="updateEndTimeEditable" size="mini") 编辑
          template(v-else)
            .button.primary.m-t-10(type="primary" @click="updateItemEndTimeData" size="mini") 保存
            .button.m-t-10(size="mini" @click="end_time_editable=false") 取消
</template>

<script>
  import ModalDialog from '@/components/generics/ModalDialog'
  import EmptyPage from '@/components/generics/EmptyPage'
  import ModalInteractions from '@/mixins/utilities/modalInteractions'
  import Api from '@/mixins/modules/customer'
  export default {
    name: 'CardProjectModal',
    components: {
      ModalDialog,
      EmptyPage,
    },
    mixins: [ModalInteractions, Api],
    props: {
      id: {
        type: [String, Number],
      },
      is_iso: {
        type: [Number, String],
        default: 2,
      },
      // 标识组件的调用位置（父组件）
      from: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        list: [],
        type: 1,
        item: [],
        expiry_type: '',
        end_time_editable: false, // 到期日期是否可编辑
      }
    },
    methods: {
      /**
       * 切换卡内项目到期日是否可编辑
       */
      updateEndTimeEditable () {
        this.list.forEach(i => {
          i.end_time_temp = i.end_time * 1000
        })
        this.end_time_editable = true
      },
      /**
       * 更新卡片的项目到期日（仅卡内项目，不包含免激活项目）
       */
      async updateItemEndTimeData () {
        const params = {
          upkeep_customer_id: this.id,
          item: this.list.map(i => {
            return {
              customer_item_id: i.customer_item_id,
              end_time: i.end_time_temp / 1000,
            }
          }),
        }
        try {
          const { response, result } = await this.updateItemExpirationDateApi(params)
          if (response.status === 200 && result.code === 0) {
            this.$store.dispatch('showMessage', {
              type: 'success',
            // autoClose: true,
              title: '更新成功！',
              resolve: () => {
                this.fetchDetail()
                this.end_time_editable = false
              },
            })
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '更新失败！',
              content: result.message,
              resolve: () => {
                this.fetchDetail()
              },
            })
          }
        } catch (error) {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '设置失败！',
            content: `服务异常，请稍后再试（${error.response ? error.response.status : error}${error.result && error.result.code ? ' ' + error.result.code : ''}）`,
          })
        }
      },
      // 获取养护卡详情
      async fetchDetail () {
        this.end_time_editable = false
        let params = {id: this.id}
        try {
          const { response, result } = this.is_iso - 0 === 1 ? await this.fetchCardDetailApi(params) : this.is_iso - 0 === 2 ? await this.fetchCardDetailTwoApi(params) : await this.fetchCardCountDetailApi(params)
          if (response.status === 200 && result.code === 0) {
            this.type = result.data.info.type
            this.expiry_type = result.data.info.expiry_type
            result.data.item.forEach(i => {
              i.end_time_temp = i.end_time * 1000
            })
            if (this.type === 1) {
              let arr = []
              let brr = []
              result.data.item.forEach(cell => {
                if (cell.type === 1) {
                  arr.push(cell)
                } else {
                  brr.push(cell)
                }
              })
              this.list = arr
              this.item = brr
            } else {
              this.list = result.data.item
            }
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '获取养护卡卡内项目失败',
              content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
            })
          }
        } catch (err) {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取养护卡卡内项目失败',
            content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
          })
        }
      },
    },
    mounted () {
      this.fetchDetail()
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/stylus/mixins'
  .w-45-p
    width  45%
  .w-35-p
    width  35%
  .w-25-p
    width  25%
  td,.multi-content-td
    vertical-align: middle
  .flex-end
    display flex
    justify-content flex-end
  .modal-header
    padding 20px 24px
  .modal-body
    position relative
    height 420px
    display flex
    flex-direction column
    overflow-x hidden
    overflow-y scroll
  .border-b
    padding-bottom 20px
    border-bottom 1px solid #72767a
  .h2
    width 100%
    font-size 16px
    font-weight bolder
    margin 10px 10px
    color #353535
    margin-left -10px
  .div-cell
    width 100%
    display flex
    justify-content start
    padding 0 15px
    line-height 40px
    font-size 13px
    .cell
      box-sizing border-box
      padding-right 10px
      min-height 40px
      line-height 20px
      word-break break-all
    .cell-name
      width 25%
    .cell-desc
      width 30%
    .cell-end
      width 20%
    .cell-num
      width 10%
  .cell-head
    background #f0f1f2
    color #999999
  .cell-body
    box-sizing border-box
    font-size 12px
    padding 8px 15px
  .l-h-20
    line-height 20px
  .content-box
    width 95%
    margin 0 auto
/deep/ .el-date-picker-dom
  .el-input__inner
    padding-right: 10px
    padding-left: 10px
  .el-input__prefix
    display: none
</style>



// WEBPACK FOOTER //
// src/components/customer/CardProjectModal.vue